export default "__VITE_ASSET__C8urXez5__"